<template>
    <div>
        <template v-if="listedItemStats">
            <!-- bonus -->
            <div class="row my-5">
                <div class="col-12">
                    <h4>Shop Exclusive</h4>
                    <p>
                        Below is an edge you have over individual sellers, 
                        you get to reach your potential buyers even before they get to buy from you 
                        <i class="far fa-smile-wink fa-xs"></i>
                    </p>
                    <hr>
                </div>
                <div class="col-sm-4 col-12">
                    <p><i class="fas fa-chart-bar"></i> Item Stats</p>
                    <p><i class="fas fa-eye"></i> {{listedItemStats.totalViews}} Total Views</p>
                    <p><i class="fas fa-eye"></i> {{listedItemStats.todayViews.length}} Views Today</p>
                    <p><i class="fas fa-heart"></i> {{listedItemStats.totalLikes.length}} Total Likes</p>
                    <p><i class="fas fa-fire"></i> Promoted {{listedItemStats.totalPromotions}} times</p>
                    <p>
                        <span v-if="listedItemStats.activePromotion"><i class="fas fa-fire text-warning"></i> Active Promotion</span>
                        <span v-else><i class="fas fa-fire"></i> Not Active Promotion</span>
                    </p>
                </div>
                <div class="col-sm-4 col-12">
                    <p><i class="fas fa-eye"></i> Recent Viewers</p>
                    <template v-if="listedItemStats.todayViews.length">
                        <p v-for="(viewer, i) in listedItemStats.todayViews.slice(0, 5)" :key="i" class="text-capitalize" 
                        :title="`Message ${viewer.name} directly about this item - aNewItem`">
                            {{i+1}}. {{viewer.name}}
                            <button @click="showChatBox = true" class="btn btn-outline-dark btn-sm">
                                <i class="fas fa-comment-dots"></i>
                            </button>
                        </p>
                    </template>
                    <template v-else>
                        <p>No views yet!</p>
                    </template>
                </div>
                <div class="col-sm-4 col-12">
                    <p><i class="fas fa-heart"></i> Recent Likers</p>
                    <template v-if="listedItemStats.totalLikes.length">
                        <p v-for="(liker, i) in listedItemStats.totalLikes" :key="i" class="text-capitalize" 
                        :title="`Message ${liker.name} directly about this item - aNewItem`">
                            {{i+1}}. {{liker.name}}
                            <button @click="showChatBox = true" class="btn btn-outline-dark btn-sm">
                                <i class="fas fa-comment-dots"></i>
                            </button>
                        </p>
                    </template>
                    <template v-else>
                        <p>No likes yet!</p>
                    </template>
                </div>
            </div>
        </template>
        
        <!-- chat box display -->
        <app-ghost-mode v-if="showChatBox">
            <div class="row">
                <div class="col-12">
                    <div class="jumbotron screen-center p-4">
                        <h3 class="md-small-text mt-3 text-center">Compose your message</h3>
                        <p class="text-center">send "potential buyers name" a deal on this item seeing they showed interest in it already</p>
                        <div class="form-group">
                            <textarea class="form-control no-lines bg-white" rows="10"></textarea>
                        </div>
                        <button class="loadn btn btn-dark-green form-control btn-lg">Send</button>
                    </div>
                </div>
            </div>
        </app-ghost-mode>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { eventBus } from '@/main'

import GhostMode from '@/components/general/shared/GhostMode.vue'

export default {
    props: ['itemId'],
    data() {
        return {
            showChatBox: false,
            forceReloadKey: 0,
        }
    },
    methods: {
        ...mapActions(['fetchItemStats']),
        updateStats(newItemId){
            this.fetchItemStats(newItemId).then(() => {}).catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['itemStats']),
        listedItemStats() {
            if(this.itemStats && this.itemStats !== null){
                return this.itemStats
            }else{
                return false
            }
        },
    },
    components: {
        appGhostMode: GhostMode,
    },
    watch: {
        itemId() {
            this.updateStats(this.itemId)
        }
    },
    created() {
        this.updateStats(this.itemId)
        eventBus.$on('hideGhostMode', (value) => {
            this.showChatBox = value;
        })
    }
}
</script>